import { AngleConstants } from "../shared/angle-constants";

export class ImageModel {
	constructor(public name: AngleConstants, public url: string) {
	}
}

export class ImageGetModel {
	public ModelGroupCode: string | undefined;
	public ModelCode: string | undefined;
	public Angle: string;
	public ComponentVariantCode: Array<{ variantCode: string, componentCode: string }>;
	public ComponentColorList: Array<[string, string | undefined, string | undefined]>;
	public ConfigurationCode: string | undefined;
	public presentAsPrecious?: boolean;
}
